const KEY = 'kadori:favourites';
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
const write = (items) => localStorage.setItem(KEY, JSON.stringify(items));
const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
const styles = `
  .kadori-wishlist-page {
    --kadori-wishlist-ink: #4c2631;
    --kadori-wishlist-muted: #746a63;
    --kadori-wishlist-paper: #fbfaf7;
    --kadori-wishlist-line: #9f7b84;
    width: 100vw;
    max-width: 100vw;
    min-height: clamp(430px, 50vh, 640px);
    margin-inline-start: calc(50% - 50vw);
    padding: clamp(18px, 2.2vw, 34px) clamp(28px, 4vw, 76px) clamp(82px, 10vw, 150px);
    background: var(--kadori-wishlist-paper);
    color: var(--kadori-wishlist-ink);
  }
  .page-block:has([data-favourites-page]) {
    align-items: stretch;
  }
  .page-block:has([data-favourites-page]) > .page-title {
    display: none !important;
  }
  .page-block:has([data-favourites-page]) .rte {
    width: 100%;
    max-width: none;
  }
  .page-block:has([data-favourites-page]) .rte > * {
    margin-block: 0;
  }
  .kadori-wishlist-breadcrumb {
    display: flex;
    align-items: center;
    gap: 14px;
    max-width: 1760px;
    margin: 0 auto clamp(42px, 6vw, 82px);
    color: var(--kadori-wishlist-muted);
    font-family: var(--font-body--family, inherit);
    font-size: 14px;
    line-height: 1;
  }
  .kadori-wishlist-breadcrumb a {
    color: inherit;
    text-decoration: none;
  }
  .kadori-wishlist-breadcrumb span {
    opacity: .68;
  }
  .kadori-wishlist-empty,
  .kadori-wishlist-saved {
    max-width: 1320px;
    margin: 0 auto;
    text-align: center;
  }
  .kadori-wishlist-title {
    margin: 0;
    color: var(--kadori-wishlist-ink);
    font-family: var(--font-heading--family, inherit);
    font-size: clamp(34px, 3.3vw, 62px);
    font-weight: 400;
    line-height: 1.08;
  }
  .kadori-wishlist-copy {
    max-width: 860px;
    margin: 28px auto 0;
    color: var(--kadori-wishlist-ink);
    font-family: var(--font-body--family, inherit);
    font-size: clamp(16px, 1.2vw, 21px);
    line-height: 1.55;
  }
  .kadori-wishlist-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    margin-top: 28px;
    padding: 0 26px;
    border: 1px solid var(--kadori-wishlist-line);
    border-radius: 8px;
    color: var(--kadori-wishlist-ink);
    background: transparent;
    font-family: var(--font-body--family, inherit);
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: .26em;
    text-transform: uppercase;
    text-decoration: none;
  }
  .kadori-wishlist-button:hover {
    background: #f3eee9;
  }
  .kadori-wishlist-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 14px;
    margin-top: 42px;
    text-align: left;
  }
  .kadori-wishlist-item {
    display: block;
    padding: 18px 0;
    border-top: 1px solid rgba(76, 38, 49, .18);
    color: var(--kadori-wishlist-ink);
    font-family: var(--font-body--family, inherit);
    font-size: 19px;
    text-decoration: none;
  }
  @media (max-width: 749px) {
    .kadori-wishlist-page {
      padding-inline: 22px;
    }
    .kadori-wishlist-breadcrumb {
      margin-bottom: 54px;
      font-size: 14px;
    }
  }
`;
const ensureStyles = () => {
  if (document.getElementById('kadori-wishlist-styles')) return;
  const style = document.createElement('style');
  style.id = 'kadori-wishlist-styles';
  style.textContent = styles;
  document.head.append(style);
};
const hideThemePageTitle = (page) => {
  const rte = page.closest('.rte');
  const block = page.closest('.page-block') || rte?.closest('.page-block');
  const title = block?.querySelector('.page-title') || (rte?.previousElementSibling?.classList?.contains('page-title') ? rte.previousElementSibling : null);
  if (title) title.hidden = true;
};
const breadcrumb = `
  <nav class="kadori-wishlist-breadcrumb" aria-label="Breadcrumb">
    <a href="/">Home</a>
    <span aria-hidden="true">›</span>
    <span>Saved pieces</span>
  </nav>
`;
const emptyState = () => `
  <section class="kadori-wishlist-page" aria-labelledby="kadori-wishlist-title">
    ${breadcrumb}
    <div class="kadori-wishlist-empty">
      <h1 id="kadori-wishlist-title" class="kadori-wishlist-title">Wishlist</h1>
      <p class="kadori-wishlist-copy">Save what you like by tapping the nearby bookmark. We’ll keep them softly here for you.</p>
      <a class="kadori-wishlist-button" href="/collections/all">Go shopping</a>
    </div>
  </section>
`;
const savedState = (items) => `
  <section class="kadori-wishlist-page" aria-labelledby="kadori-wishlist-title">
    ${breadcrumb}
    <div class="kadori-wishlist-saved">
      <h1 id="kadori-wishlist-title" class="kadori-wishlist-title">Wishlist</h1>
      <p class="kadori-wishlist-copy">Pieces you have saved for another look.</p>
      <div class="kadori-wishlist-grid">
        ${items.map((item) => `<a class="kadori-wishlist-item" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>`).join('')}
      </div>
      <a class="kadori-wishlist-button" href="/collections/all">Continue shopping</a>
    </div>
  </section>
`;
const sync = () => {
  const items = read();
  document.querySelectorAll('[data-favourites-count]').forEach((node) => { node.textContent = items.length; node.hidden = items.length === 0; });
  document.querySelectorAll('[data-favourite-id]').forEach((button) => {
    const active = items.some((item) => String(item.id) === String(button.dataset.favouriteId));
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.querySelector('span').innerHTML = '<svg viewBox="0 0 24 24" role="presentation"><path d="M8.5 4h7A1.5 1.5 0 0 1 17 5.5V20l-5-3.1L7 20V5.5A1.5 1.5 0 0 1 8.5 4Z" /></svg>';
    button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${button.dataset.favouriteTitle} ${active ? 'from' : 'to'} favourites`);
  });
  const page = document.querySelector('[data-favourites-page]');
  if (page) {
    ensureStyles();
    hideThemePageTitle(page);
    const items = read();
    page.innerHTML = items.length ? savedState(items) : emptyState();
  }
};
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-favourite-id]');
  if (!button) return;
  event.preventDefault(); event.stopPropagation();
  const items = read();
  const index = items.findIndex((item) => String(item.id) === String(button.dataset.favouriteId));
  if (index >= 0) items.splice(index, 1); else items.push({ id: button.dataset.favouriteId, title: button.dataset.favouriteTitle, url: button.dataset.favouriteUrl });
  write(items); sync();
});
window.addEventListener('storage', sync);
sync();
